import request from '@/utils/request'

export function getOrderPrice(data) {
	return request({
		url: '/open/order/price',
		method: 'post',
		data
	})
}
export function createOrder(data) {
	return request({
		url: '/open/order/store',
		method: 'post',
		data
	})
}

export function uploadFile(data) {
	return request({
		url: '/open/order/store',
		method: 'post',
		data
	})
}
